import React from 'react';
import { Link } from 'gatsby';

import SEO from '../../../components/seo';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

import '../../../components/layout.css';

const steps = [
  {
    num: '01',
    title: 'Source',
    subtitle: 'Rice Husk Feedstock',
    desc: 'Rice husk sourced from partner mills within ~5-20 km of each facility in Kalahandi and Sambalpur districts.',
  },
  {
    num: '02',
    title: 'Prepare',
    subtitle: 'Biomass Preparation',
    desc: 'Feedstock prepared for conversion in the plant’s controlled slow pyrolysis system.',
  },
  {
    num: '03',
    title: 'Pyrolyse',
    subtitle: 'Controlled Pyrolysis',
    desc: 'Biomass undergoes controlled slow pyrolysis at 450-600°C under low-oxygen conditions, producing stable biochar.',
  },
  {
    num: '04',
    title: 'Recover',
    subtitle: 'Syngas Recovery',
    desc: 'Syngas produced during pyrolysis is recovered and used to provide process heat for the facility.',
  },
  {
    num: '05',
    title: 'Apply',
    subtitle: 'Soil Application',
    desc: 'Biochar is incorporated into agricultural soils through MatiBoost™, a biochar-enhanced soil amendment product.',
  },
];

const ProcessPage = () => (
  <div className="theme-default bg-background text-foreground">
    <SEO title="Process" />
    <Header />

    <main>
      {/* OCF secondaryHero */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <span className="chip mb-6 inline-flex">Project Kalinga</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight tracking-tight mt-4">
            Process
          </h1>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: intro */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">Overview</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="prose prose-lg max-w-none">
                <p>
                  Project Kalinga follows a five-step process from rice husk
                  sourcing to biochar soil application. Each step is designed
                  for traceability and permanence verification.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF numbered process steps */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">How it works</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="space-y-8">
                {steps.map(({ num, title, subtitle, desc }) => (
                  <div
                    key={num}
                    className="bg-background-raised rounded border border-border p-6"
                  >
                    <div className="flex items-baseline gap-4 mb-2">
                      <span className="font-mono text-sm text-muted-foreground">
                        {num}
                      </span>
                      <h3 className="text-xl md:text-2xl font-normal">
                        {title}
                      </h3>
                    </div>
                    <div className="font-mono text-sm text-muted-foreground mb-2">
                      {subtitle}
                    </div>
                    <p className="text-base leading-relaxed">{desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF bottomCTA */}
      <section className="section theme-orange">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-7 md:col-start-6">
              <h2 className="text-3xl md:text-4xl font-light tracking-tight mb-6 leading-tight">
                Ready to explore Project Kalinga?
              </h2>
              <div className="flex flex-wrap gap-4">
                <Link to="/diligence" className="button-split group">
                  <span className="button-split-circle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </span>
                  <span className="button-split-pill">
                    Request diligence access
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default ProcessPage;
